{
  "name": "@oramacloud/client",
  "version": "2.1.4",
  "description": "Orama SDK client for Node.js, Deno, and Browsers",
  "type": "module",
  "sideEffects": false,
  "main": "./dist/index.js",
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "runkitExampleFilename": "./example/runkit.js",
  "exports": {
    "types": "./dist/index.d.ts",
    "browser": {
      "import": "./dist/index.js",
      "require": "./dist/index.global.js"
    },
    "import": "./dist/index.js",
    "require": "./dist/index.cjs",
    "default": "./dist/index.js"
  },
  "scripts": {
    "watch": "tsup --config tsup.lib.js --watch src",
    "build": "tsup --config tsup.lib.js",
    "test": "glob -c \"node --import tsx --no-warnings --test\" \"./tests/**/*.test.ts\"",
    "serve:example": "esbuild src/index.ts --bundle --outfile=example/out.js --format=esm --watch --servedir=example"
  },
  "keywords": [
    "orama",
    "search engine",
    "sdk"
  ],
  "files": [
    "dist",
    "example/runkit.js"
  ],
  "author": {
    "name": "Michele Riva",
    "email": "michele.riva@oramasearch.com",
    "url": "https://github.com/MicheleRiva"
  },
  "license": "ISC",
  "dependencies": {
    "@orama/cuid2": "^2.2.3",
    "@orama/orama": "^3.0.0",
    "lodash": "^4.17.21"
  },
  "devDependencies": {
    "@fastify/formbody": "^7.4.0",
    "@types/lodash": "^4.14.202",
    "@types/node": "^20.3.1",
    "dotenv": "^16.3.1",
    "esbuild": "0.18.5",
    "fastify": "^4.19.2",
    "glob": "^11.0.0",
    "husky": "^8.0.3",
    "npm-run-all": "^4.1.5",
    "ts-standard": "^12.0.2",
    "tsup": "^8.3.0",
    "tsx": "^4.7.0",
    "typescript": "^5.1.3"
  },
  "publishConfig": {
    "access": "public"
  },
  "ts-standard": {
    "ignore": [
      "dist",
      "node_modules"
    ]
  }
}